import { useCallback } from "react";
import { useSignUpload } from "app/hooks";
import { Media } from "chq";
import { SetState } from "../types";
import KEYS from "../constants";

interface Props {
  setState: SetState;
}

const useUploadVideos = ({ setState }: Props) => {
  const signUpload = useSignUpload();

  return useCallback(
    async (videos: File [], visualsThumb) => {
      const videosProgress = videos.map(_ => 0);
      const processedUrls = await Promise.all(
        videos.map(async (video, index: number) => {
          if (process.env.NODE_ENV === "development") {
            return {
              mediaUrl: KEYS.DEVELOPMENT_VIDEO_URL,
              thumbUrl: visualsThumb,
              fullUrl: "",
              smallUrl: ""
            } as Media;
          }

          const mediaUrl = await signUpload(
            video,
            (mediaProgress: number) => {
              videosProgress[index] = (mediaProgress * 9) / (videos.length * 10);
              setState({
                progress: videosProgress.reduce(
                  (progress: number, current: number) => progress + current,
                  0
                )
              });
            }
          );

          return {
            mediaUrl,
            thumbUrl: visualsThumb,
            fullUrl: "",
            smallUrl: ""
          } as Media;
        })
      );

      return processedUrls;
    },
    [setState, signUpload]
  );
};

export default useUploadVideos;
